import en from './en.json';
import fr from './fr.json';
import { AVAILABLE_LANGUAGES } from '../../../../server/utils/constants';

export default { [AVAILABLE_LANGUAGES.FR]: fr, [AVAILABLE_LANGUAGES.EN]: en };
